// The fans per community, as counts only: { _id: community id, count }, filled by the publication
// 'communityFanCounts' (core/server/userData.js, #520). The browser no longer gets the other users' communities.
import { Mongo } from 'meteor/mongo';
export var FanCounts = new Mongo.Collection('fanCounts');